<div class="PGLoginHandlerCode">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <div class="form-group">
        <label for="pg-login-code">
            <b>{{ 'pg-login-handler.input-code' | locTranslate }}</b>
        </label>
        <input id="pg-login-code" class="form-control" [(ngModel)]="loginCode" (keyup)="onLoginCodeKeyUp($event)" [attr.aria-invalid]="loginError || null" [attr.aria-describedby]="loginError ? 'pg-login-code-error' : null"/>
    </div>
    <div class="form-group">
        @if (loginError) {
            <div id="pg-login-code-error" class="text-danger" role="alert">{{ 'pg-login-handler.check-failed' | locTranslate }}</div>
        }
    </div>
    <button type="button" class="btn btn-primary btn-block" [disabled]="!canLoginCode()" (click)="doLoginCode()">
        <i class="fa-regular fa-sign-in-alt" aria-hidden="true"></i>
        <span>{{ 'pg-login-handler.button-check' | locTranslate }}</span>
    </button>
</div>
